// extracted by mini-css-extract-plugin
module.exports = {"markdown":"MarkdownRenderer_markdown__Cylgf","regular":"MarkdownRenderer_regular__gGM3j"};